module.exports = __webpack_public_path__ + "media/images/icons/SVG/058-78756cc58902826e5dc6c34fb287b999.svg";